import * as React from 'react'
import { createRemoveFromCartEvent, createSubmitEvent } from '@/scopes/checkout/domain/analytics/index'
import { useSelectedServicesStorage } from '@/scopes/checkout/domain/analytics/useSelectedServicesStorage'
import { useBookingDraftQuery } from '@/scopes/checkout/domain/hooks'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'

export function useSendSubmitEvent() {
  const { data } = useBookingDraftQuery()
  const {
    getItems,
    clearItems,
    getRemovedItems,
    clearRemovedItems,
    markSubmittedToStep2,
  } = useSelectedServicesStorage()
  const { sendEvent } = useAnalytics()

  const sendSubmitEvent = React.useCallback(() => {
    if (!data?.analytics)
      return

    const removedItems = getRemovedItems()
    if (removedItems.length) {
      sendEvent(createRemoveFromCartEvent(removedItems, data.analytics))
      clearRemovedItems()
    }

    const selectedServiceItems = getItems().map((item, index) => ({
      ...item,
      index: index + 1,
    }))

    sendEvent(createSubmitEvent(selectedServiceItems, data.analytics))
    clearItems()
    markSubmittedToStep2()
  }, [
    data,
    getItems,
    clearItems,
    getRemovedItems,
    clearRemovedItems,
    markSubmittedToStep2,
    sendEvent,
  ])

  return {
    sendSubmitEvent,
  }
}
